var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CCard',[_c('CCardBody',[_c('CDataTableFixed',{attrs:{"items":_vm.items,"fields":_vm.fields,"items-per-page":20,"hover":"","sorter":"","pagination":""},scopedSlots:_vm._u([{key:"row",fn:function(ref){
var item = ref.item;
return [_c('td',[_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(item.id))])])]}},{key:"name",fn:function(ref){
var item = ref.item;
return [_c('td',[_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(item.name))])])]}},{key:"count",fn:function(ref){
var item = ref.item;
return [_c('td',[_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(item.slider_count))])])]}},{key:"operation",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_c('td',{staticClass:"py-2"},[_c('CButton',{attrs:{"color":"primary","variant":"outline","square":"","size":"sm"},on:{"click":function($event){return _vm.goSliderImages(item,index)}}},[_vm._v(_vm._s(_vm.$t('slider_images'))+" ")])],1)]}}])})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }